// src/hooks/useComments.js
import { useState } from 'react';

/**
 * Manages comment-input state and submissions.
 */
export default function useComments() {
  const [commentInput, setCommentInput] = useState(null);
  const [comments, setComments]         = useState([]);

  const submitComment = () => {
    if (!commentInput?.text?.trim()) return;
    setComments(prev => [
      ...prev,
      { ...commentInput, text: commentInput.text.trim(), id: prev.length + 1 },
    ]);
    setCommentInput(null);
  };

  return { commentInput, setCommentInput, comments, submitComment };
}
